/* akosin-header.js — transparent-to-opaque scroll effect */
(function () {
  const SCROLL_THRESHOLD = 20;

  function init() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    function update() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        headerWrapper.classList.add('ak-scrolled');
      } else {
        headerWrapper.classList.remove('ak-scrolled');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update(); // run once on load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* akosin scroll-reveal — IntersectionObserver-based entrance animations */
(function () {
  var observer;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function akRevealInit() {
    var elements = document.querySelectorAll('.ak-reveal:not(.is-visible)');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(reveal);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -50px 0px', threshold: 0.08 }
      );
    }

    elements.forEach(function (el) { observer.observe(el); });
  }

  window.akRevealInit = akRevealInit;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', akRevealInit);
  } else {
    akRevealInit();
  }
})();
